"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// load font via webpack asset/resource
// require("src/tokens/index.css");

class Link extends HTMLElement {
    /**
     * Focuses the inner anchor (the host itself is not focusable), so a dialog
     * can give the focus back to the link that opened it.
     */
    focus() {
        this.a.focus();
    }

    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.a = this.root.querySelector("a");
        // this.href = this.getAttribute("href");
        // if (this.href) {
        //     this.button = document.createElement("a");
        //     this.button.setAttribute("href", this.href);
        //     this.button.setAttribute("rel", "noopener");
        //     this.button.setAttribute("target", "_blank");
        // } else {
        //     this.button = document.createElement("button");
        // }
        //
        // // arrow
        // this.iconName = this.gettAttribute("icon");
        // // this.button = this.root.appendChild(this.button);
        // //
        // if (this.innerHTML) {
        //     this.a.innerHTML = this.innerHTML;
        //     if (this.iconName) {
        //         const icon = document.createElement("div");
        //         icon.className = this.iconName;
        //         this.a.appendChild(icon);
        //     }
        //
        // }
        // if (this.hasAttribute("href")) {
        //     this.a.setAttribute("href", this.getAttribute("href"));
        //     this.removeAttribute("href");
        // }
        // this.innerHTML = "";

    }

    get href() {
        return this.a.getAttribute("href");
    }
    set href(href) {
        this.a.setAttribute("href", href);
    }

    connectedCallback() {
        // arrow
        this.iconName = this.getAttribute("icon");
        // this.button = this.root.appendChild(this.button);
        //
        if (this.innerHTML) {
            this.a.innerHTML = this.innerHTML;
            if (this.iconName) {
                const icon = document.createElement("div");
                icon.className = this.iconName;
                this.a.appendChild(icon);
            }

        }
        if (this.hasAttribute("href")) {
            this.a.setAttribute("href", this.getAttribute("href"));
            this.removeAttribute("href");
        } else {
            // no href: the link is an ACTION (e.g. "open the dialog"). An anchor
            // without href is neither focusable nor keyboard-operable, so it
            // takes a button's role, a tab stop, and Enter/Space fire its click
            // (composed, so the page sees it on the host as a tap).
            this.a.setAttribute("role", "button");
            this.a.setAttribute("tabindex", "0");
            this.a.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    this.a.click();
                }
            }.bind(this));
        }
        if (this.hasAttribute("external")) {
            this.a.setAttribute("target", "_blank");
        }
        this.innerHTML = "";
    }




}

window.customElements.define("swiftref-link", Link);

module.exports = Link;
